<template>
  <div class="mobile-i18n-page category">
    <!-- 分类 -->
    <!-- 全部分类 -->
    <van-nav-bar :title="$t('mobile.category.all')" fixed />

    <!-- 搜索框 -->
    <!-- 请输入搜索关键词 -->
    <van-search
      readonly
      shape="round"
      background="#f1f1f2"
      :placeholder="$t('mobile.category.searchPlaceholder')"
      @click="$router.push('/search')"
    />

    <!-- 分类列表 -->
    <div class="list-box">
      <div class="left">
        <ul>
          <li v-for="(item, index) in list" :key="item.id">
            <a
              :class="{ active: index === activeIndex }"
              @click="activeIndex = index"
              href="javascript:;"
              >{{ item.name }}</a
            >
          </li>
        </ul>
      </div>
      <div class="right">
        <div
          @click="$router.push(`/searchlist?categoryId=${item.id}`)"
          v-for="item in list[activeIndex]?.children"
          :key="item.id"
          class="cate-goods"
        >
          <img :src="item.picture" alt="" />
          <p>{{ item.name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCategoryData } from "@/api/category";
export default {
  name: "CategoryPage",
  created() {
    this.getCategoryList();
  },
  data() {
    return {
      list: [],
      activeIndex: 0,
    };
  },
  methods: {
    async getCategoryList() {
      // const {
      //   data: { list },
      // } = await getCategoryData();
      // this.list = list;
      getCategoryData()
        .then((resp) => {
          this.list = resp.data;
        })
        .catch((error) => {
          console.error("Error fetching banner data:", error);
        });
    },
  },
};
</script>

<style lang="less" scoped>
// 主题 padding
.category {
  padding-top: 100px;
  padding-bottom: 50px;
  height: 100vh;
  .list-box {
    height: 100%;
    display: flex;
    .left {
      width: 85px;
      height: 100%;
      background-color: #f3f3f3;
      overflow: auto;
      a {
        display: block;
        height: 45px;
        line-height: 45px;
        text-align: center;
        color: #444444;
        font-size: 12px;
        &.active {
          color: #fb442f;
          background-color: #fff;
        }
      }
    }
    .right {
      flex: 1;
      height: 100%;
      background-color: #ffffff;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-content: flex-start;
      padding: 10px 0;
      overflow: auto;

      .cate-goods {
        width: 33.3%;
        margin-bottom: 10px;
        img {
          width: 70px;
          height: 70px;
          display: block;
          margin: 5px auto;
        }
        p {
          text-align: center;
          font-size: 12px;
        }
      }
    }
  }
}

// 导航条样式定制
.van-nav-bar {
  z-index: 999;
}

// 搜索框样式定制
.van-search {
  position: fixed;
  width: 100%;
  top: 46px;
  z-index: 999;
}
</style>
